import { handleInvalidEventProps } from './validateEventProps';
import emitEventResetPassword from './emitEventResetPassword';
import { reportTrackerFailure } from '../rollbar';

export default ({ getCalltimePayload, name, version }) => (payload) => {
  const { stage } = payload;
  if (!(Number.isInteger(version) && name && stage)) {
    handleInvalidEventProps(payload);
  }
  return emitEventResetPassword({
    error: (error) => reportTrackerFailure(error, name, payload),
    name,
    payload: {
      ...getCalltimePayload(payload),
    },
    version,
  });
};
